import { Framework } from '@/framework';
import { IDragData, IPoint } from '@/version-types';
import { getDragLayerState } from './states/drag-state';

export class DragLayerPlugin extends Framework {
    getUploadName() {
        return 'gs-stage-upload';
    }

    destroy() {
        const state = getDragLayerState(this.framework.identity);
        state.ghost?.remove();
        state.reset();
    }

    setDragData(dragData: IDragData | null) {
        getDragLayerState(this.framework.identity).setDragData(dragData);
    }

    setGhost(ghost: HTMLElement | null) {
        getDragLayerState(this.framework.identity).setGhost(ghost);
    }

    reset() {
        this.destroy();
    }

    emitUploadFile(files: FileList, position: IPoint) {
        this.framework.service.events.emit(this.getUploadName(), files, position);
    }

    onUploadFile(fn: (files: FileList, position: IPoint) => void) {
        return this.framework.service.events.on(this.getUploadName(), fn);
    }

    offUploadFile(handle: number) {
        this.framework.service.events.off(handle);
    }
}
